export const isProduction =
  import.meta.env.VITE_PUBLIC_ENVIRONMENT === "production";
export const isTest = import.meta.env.VITE_PUBLIC_ENVIRONMENT === "test";
export const MIN_CHILD_AGE = 2;
export const MIN_ADULT_AGE = 12;
export const MAX_CHILDREN_PER_ROOM = 8;
export const MAX_VISITORS_PER_ROOM = 9;
export const MAX_TRAVELLERS = 9;
export const HOTEL_CLASSES = [0, 1, 2, 3, 4, 5];
export const BOARD_BASIS_OPTIONS = ["HB", "FB", "AI", "RO", "SC", "BB", "RD"];
export const SUPPORTED_BAGGAGE_ADDITIONAL_SERVICES_CODES = ["BG", "CY"];
export const SUPPORTED_MEAL_ADDITIONAL_SERVICES_CODES = ["ML"];
export const SUPPORTED_ADDITIONAL_SERVICES_CODES = [
  ...SUPPORTED_BAGGAGE_ADDITIONAL_SERVICES_CODES,
  ...SUPPORTED_MEAL_ADDITIONAL_SERVICES_CODES,
];

// TZ SUPPORT WHATSAPP NUMBER
export const WHATSAPP_URL = "https://wa.me/9647805022222";
